import { Component, Input } from '@angular/core';
import {EJobType} from '../job-type.enum';

@Component({
  selector: 'job-steps',
  templateUrl: 'jobs-steps.component.html',
  styleUrls: ['jobs-steps.component.scss']
})
export class JobsStepsComponent {
  @Input() currentJob;
  @Input() jobType: EJobType;
  public jobTypes = EJobType;

}
